export const getMapOptions = ({ map, center, }) => {
    const zoom = map.getZoom();
    const mapCenter = map.getCenter();
    const mapBounds = map.getBounds();
    const ne = mapBounds.getNorthEast();
    const sw = mapBounds.getSouthWest();
    const isDestinationOutOfBounds = !mapBounds.contains(center);
    return {
        zoom,
        mapCenter: {
            latitude: mapCenter.lat(),
            longitude: mapCenter.lng(),
        },
        mapBounds: {
            northEast: {
                latitude: ne.lat(),
                longitude: ne.lng(),
            },
            southWest: {
                latitude: sw.lat(),
                longitude: sw.lng(),
            },
        },
        isDestinationOutOfBounds,
    };
};
